import React from "react"
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom"
import LogIn from "./LogIn.jsx"
import V2Layout from "./v2/layout/Layout.jsx"
import V2ManifestsPage from "./v2/pages/ManifestsPage.jsx"
import V2ManifestPage from "./v2/pages/ManifestPage.jsx"
import V2OrdersPage from "./v2/pages/OrdersPage.jsx"
import V2OrderDetailPage from "./v2/pages/OrderDetailPage.jsx"
import V2CustomersPage from "./v2/pages/CustomersPage.jsx"
import V2OrderFormNewPage from "./v2/pages/OrderFormNewPage.jsx"
import V2OrderFormEditPage from "./v2/pages/OrderFormEditPage.jsx"
import V2OfflineQueuePage from "./v2/pages/OfflineQueuePage.jsx"
import V2ExampleItemsPage from "./v2/pages/ExampleItemsPage.jsx"
import V2FishRoomPage from "./v2/pages/FishRoomPage.jsx"
import V2AppProvider from "./v2/V2AppProvider.jsx"
import auth from "./db/auth.js"
import "./index.css"

function RequireAuth({ children }) {
  const location = useLocation()
  if (!auth.getJwt()) {
    return <Navigate replace to="/log-in" state={{ from: location.pathname }} />
  }
  return children
}

/** Do not SPA-redirect /api — those URLs should be served by the backend (or dev proxy). */
function SpaFallbackRedirect() {
  const { pathname } = useLocation()
  if (pathname.startsWith("/api")) {
    return null
  }
  return <Navigate replace to="/" />
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RequireAuth><Outlet /></RequireAuth>}>
            <Route index element={<Navigate replace to="/v2/orders" />} />
          </Route>
          <Route path="/v2" element={<V2AppProvider><V2Layout /></V2AppProvider>}>
            <Route index element={<Navigate replace to="orders" />} />
            <Route path="orders" element={<V2OrdersPage />} />
            <Route path="orders/:orderId/edit" element={<V2OrderFormEditPage />} />
            <Route path="orders/:orderId/order" element={<V2OrderDetailPage />} />
            <Route path="order-form" element={<V2OrderFormNewPage />} />
            <Route path="order-form/:orderId" element={<V2OrderFormEditPage />} />
            <Route path="manifests" element={<V2ManifestsPage />} />
            <Route path="manifests/:manifestId" element={<V2ManifestPage />} />
            <Route path="customers" element={<V2CustomersPage />} />
            <Route path="offline-queue" element={<V2OfflineQueuePage />} />
            <Route path="example-items" element={<V2ExampleItemsPage />} />
            <Route path="fish-room" element={<V2FishRoomPage />} />
          </Route>
          <Route path="/log-in" element={<LogIn />} />
          <Route path="*" element={<SpaFallbackRedirect />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App

